var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content-wrapper"},[_c('HeaderRegistered',{attrs:{"return-path":_vm.returnPath,"sub-title":_vm.caseTitle}}),_c('main',{staticClass:"main"},[_c('div',{staticClass:"dashboard-section"},[_c('CaseAssignList')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }